module.exports = __webpack_public_path__ + "static/media/no-project-found.67f11cbf.svg";